import { render, staticRenderFns } from "./MenuSettings.vue?vue&type=template&id=12ba3ac8&scoped=true&"
import script from "./MenuSettings.vue?vue&type=script&lang=js&"
export * from "./MenuSettings.vue?vue&type=script&lang=js&"
import style0 from "./MenuSettings.vue?vue&type=style&index=0&id=12ba3ac8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba3ac8",
  null
  
)

export default component.exports